var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChileautos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "345px",
    height: "125px",
    viewBox: "0 0 345 125",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chileautos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-17",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-19",
    points: "0 124.45981 345 124.45981 345 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chileautos"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.406845,124 L74.406845,102.415823 C74.406845,99.3388435 74.406845,90.0046335 64.2939587,90.0046335 C57.934025,90.0046335 53.6095514,94.3845804 53.6095514,102.348121 L53.6095514,124 L46,124 L46,71 L53.6095514,71.0166385 L53.6095514,88.5042978 L53.7635579,88.5042978 C57.421061,83.1971833 63.4958195,83.1971833 65.0961971,83.1971833 C71.3987445,83.1971833 76.5219429,85.8484456 79.4521619,90.2955207 C81.0572238,92.87736 81.9484696,96.0381053 82,100.481738 L82,124 L74.406845,124 Z",
    id: "Fill-1",
    fill: "#007CC2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fill-3-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#007CC2",
    mask: "url(#mask-2)",
    points: "100.03125 124.45981 107.21875 124.45981 107.21875 71.1198913 100.03125 71.1198913"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-5-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.25,124.45981 L94.4375,124.45981 L94.4375,84.5237144 L87.25,84.5237144 L87.25,124.45981 Z M87.25,79.913949 L94.4375,79.913949 L94.4375,71.1198913 L87.25,71.1198913 L87.25,79.913949 Z",
    id: "Fill-5",
    fill: "#007CC2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-6-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.675637,102.589896 C143.32033,97.1565716 138.148706,91.723787 131.173,91.723787 C124.18099,91.723787 119.019484,97.1565716 118.671486,102.589896 L143.675637,102.589896 Z M118.671486,107.957882 C120.488498,115.136977 126.492732,118.082592 131.386633,118.082592 C136.754464,118.082592 140.663963,115.062459 142.409576,111.849551 L149.678185,111.849551 C145.975573,121.435897 137.1019,124.45981 131.099352,124.45981 C120.136564,124.45981 111.40625,115.401029 111.40625,104.869711 C111.40625,93.7368495 120.342327,85.3438697 131.24496,85.3438697 C141.723699,85.3438697 150.86835,93.5338154 150.9375,104.401004 C150.9375,105.60787 150.802573,107.489175 150.727239,107.957882 L118.671486,107.957882 Z",
    id: "Fill-6",
    fill: "#007CC2",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-7-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3450528,98.6902375 C30.1581085,96.3471558 27.3031501,91.7113163 20.302181,91.7113163 C10.7625813,91.7113163 7.37621505,99.2167543 7.37621505,104.869372 C7.37621505,111.310953 11.6789595,118.088034 20.1465912,118.088034 C25.6826136,118.088034 29.4264932,115.0772 31.27069,111.237901 L39.53125,111.237901 C36.5561671,119.490095 28.8968015,124.45981 20.1465912,124.45981 C7.24007398,124.45981 0,114.466809 0,104.869372 C0,94.7832971 7.80694712,85.3438697 20.2146618,85.3438697 C31.3450528,85.3438697 38.0445666,93.1842654 39.53125,98.6902375 L31.3450528,98.6902375 Z",
    id: "Fill-7",
    fill: "#007CC2",
    mask: "url(#mask-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-8-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.292809,91.7060322 C165.685788,91.7060322 161.523777,99.1604745 161.523777,104.985424 C161.523777,111.71168 166.826994,118.081417 174.221246,118.081417 C181.559116,118.081417 187.214725,112.098495 187.214725,104.985424 C187.214725,97.0732957 181.500023,91.7060322 174.292809,91.7060322 Z M187.080274,123.508731 L187.080274,117.730308 L186.953955,117.730308 C184.26006,122.303383 179.357485,124.45981 174.292809,124.45981 C161.729248,124.45981 154.53125,114.856514 154.53125,105.071984 C154.53125,95.9940005 160.913326,85.3438697 174.292809,85.3438697 C179.487598,85.3438697 184.26006,87.4737875 186.953955,91.5637495 L187.080274,91.5637495 L187.080274,86.3393101 L194.0625,86.3393101 L194.0625,123.508731 L187.080274,123.508731 Z",
    id: "Fill-8",
    fill: "#007CC2",
    fillRule: "nonzero",
    mask: "url(#mask-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-9-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.914971,91.7060322 C275.458462,91.7060322 269.833967,98.2034452 269.833967,104.874519 C269.833967,111.561282 275.530556,118.081417 283.914971,118.081417 C291.997057,118.081417 297.984347,111.84152 297.984347,104.786336 C297.984347,98.2034452 292.348806,91.7060322 283.914971,91.7060322 M283.914971,124.45981 C270.49386,124.45981 262.34375,114.059621 262.34375,104.645135 C262.34375,94.5192337 271.496199,85.3438697 283.914971,85.3438697 C296.052344,85.3438697 305.46875,94.1870596 305.46875,104.786336 C305.46875,113.844844 297.462828,124.45981 283.914971,124.45981",
    id: "Fill-9",
    fill: "#007CC2",
    fillRule: "nonzero",
    mask: "url(#mask-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-10-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.857204,85.3438697 L208.857204,105.997646 C208.857204,115.437453 213.319876,117.914951 218.956066,117.914951 C225.251622,117.914951 229.564358,114.127926 229.564358,105.798358 L229.564358,85.3438697 L237.1875,85.3438697 L237.1875,123.483355 L230.241433,123.483355 L230.241433,119.339388 L230.089136,119.339388 C228.041973,122.659557 223.267622,124.45981 218.15739,124.45981 C213.535336,124.45981 209.504173,123.077563 206.592811,120.681112 C203.212159,117.914951 201.25,113.657739 201.25,105.997646 L201.25,85.3438697 L208.857204,85.3438697 Z",
    id: "Fill-10",
    fill: "#007CC2",
    mask: "url(#mask-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-11-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.576409,95.8637279 C314.649155,94.3571053 315.95136,91.3325043 320.572104,91.3325043 C325.220614,91.3325043 326.762158,95.1726067 326.952075,96.4120822 L333.90235,96.4358764 C333.90235,93.5291663 330.834255,85.3438697 320.624859,85.3438697 C310.433787,85.3438697 308.073715,92.3518808 307.914896,95.6068558 C307.354587,107.698771 327.901101,105.553484 327.549034,113.40025 C327.483508,114.860365 326.028037,118.377079 320.113417,118.377079 C314.321521,118.377079 312.487884,113.7112 312.3485,111.827111 L305.46875,111.827111 C305.846362,115.477939 308.540732,124.45981 320.20671,124.45981 C331.841034,124.45981 334.092266,116.429177 334.20666,113.446757 C334.786405,100.844342 314.321521,101.6155 314.576409,95.8637279",
    id: "Fill-11",
    fill: "#007CC2",
    mask: "url(#mask-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-12-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#007CC2",
    mask: "url(#mask-18)",
    points: "255.458984 124.45981 247.593994 124.45981 247.593994 91.3740918 240.78125 91.3740918 240.78125 84.5271264 247.593994 84.5271264 247.593994 71.1198913 255.458984 71.1198913 255.458984 84.5271264 262.34375 84.5271264 262.34375 91.3740918 255.458984 91.3740918"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Fill-13-Clipped"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.493992,74.6758861 C306.25528,47.719553 252.716562,45.4276136 252.194508,45.4198555 L249.781787,45.3583456 L248.004982,43.7768187 C247.659413,43.4797975 212.776299,12.7746807 164.369309,12.7746807 C106.63708,12.7746807 67.4323603,54.8403029 67.0423852,55.2802933 L64.8465704,57.6248764 L3.59375,51.8800659 L5.52085234,39.4367632 L59.6214754,44.3409373 C69.3981755,34.8251772 108.355247,0 164.369309,0 C211.97927,0 246.725181,26.1234546 254.943689,32.7914688 C266.283704,33.4664162 314.637179,37.9749314 345,65.0204817 L336.493992,74.6758861 Z",
    id: "Fill-13",
    fill: "#007CC2",
    mask: "url(#mask-20)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChileautos);
export default __webpack_public_path__ + "static/media/chileautos.a1b9fbbec1492ba954b20cfb0ed03973.svg";
export { ForwardRef as ReactComponent };